// extracted by mini-css-extract-plugin
export default {"cropContainer":"styles_cropContainer__4J8W7"};